import React from "react";
import "./NotComingGuests.scss";
import { useNavigate } from "react-router-dom";
import StatusGuestsListComponent from "../StatusGuestsListComponent/StatusGuestsListComponent";

const NotComingGuests = () => {
  const navigate = useNavigate();

  const handleGoBack = () => navigate("/dashboard");

  return (
    <div className="add-all-guests-container">
      <div className="notparticipatingGuestsPage">
        <StatusGuestsListComponent
          statusFilter="Not Participating"
          showMobileWhatsApp={false}
        />
      </div>
    </div>
  );
};

export default NotComingGuests;